import React from 'react';

import { Elements } from '@stripe/react-stripe-js';
import Payment from '.';
import { initStripe } from '../../core/api/payment';

const stripePromise = initStripe();
const StripePayment = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <Payment />
    </Elements>
  );
};
export default StripePayment;
